import AdditionalDeliveryInfo from './AdditionalDeliveryInfo';

export default AdditionalDeliveryInfo;
